<template>
  <div>
    <header class="form-title">
      <Row>
        <Col span="22">
          <Form inline :label-width="80">
            <FormItem label="选择时间">
              <DatePicker
                split-panels
                type="daterange"
                :options="options"
                placeholder="选择日期"
                @on-change="modifyTime"
                :value="valuedate"
              ></DatePicker>
            </FormItem>
            <FormItem label="客户名称">
              <Select v-model="search.name" filterable style="width: 150px">
                <Option value>全部</Option>
                <Option
                  :value="k.id"
                  v-for="(k,v) in customerList"
                  v-if="k.isdel!=0"
                  :key="v"
                >{{k.name}}</Option>
              </Select>
            </FormItem>
            <FormItem label="客户电话">
              <Input v-model="search.phone" style="width: 150px" disabled />
            </FormItem>
            <FormItem label="开单人">
              <Select v-model="search.openorderName" filterable style="width: 150px">
                <Option value>全部</Option>
                <Option :value="adminuserid">{{adminusername}}</Option>
                <Option :value="k.id" v-for="(k,v) in salesman" :key="v">{{k.name}}</Option>
              </Select>
              <Button type="primary" style="margin-left: 15px" @click="searchCondition">搜索</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="2">
          <Button
            type="primary"
            style="position: relative;top: -10px;right: 10px"
            @click="$router.push({path:'/newsale'})"
          >
            <Icon type="md-add" />新增销售单
          </Button>
        </Col>
      </Row>
    </header>
    <Table stripe :columns="columns" :data="data" :loading="loadingTable" class="tableList">
      <template slot-scope="{ row, index }" slot="action">
        <ButtonGroup shape="circle">
          <Button type="primary" size="small" @click="queryManuscript(row)">开单</Button>
          <Button type="primary" size="small" @click="deleteManuscript(row)">删除</Button>
        </ButtonGroup>
      </template>
    </Table>
    <div class="pageTotal">
      <Page :total="page.total" show-total :page-size="page.rows" @on-change="onGongPageTotal" />
    </div>
    <div class="demo-spin-container" v-if="openorderloading">
      <Spin fix>
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>开单加载中...</div>
      </Spin>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cid: "",
      sid: "",
      customerList: [], //客户列表
      salesman: [], //开单人
      adminuserid: JSON.parse(localStorage.getItem("adminUser")).id,
      adminusername: JSON.parse(localStorage.getItem("adminUser")).name,
      search: {
        name: "",
        phone: "",
        openorderName: ""
      },
      data: [],
      columns: [
        { title: "客户姓名", key: "customerName", align: "center" },
        { title: "客户电话", key: "customerPhone", align: "center" },
        { title: "开单人", key: "adminName", align: "center" },
        { title: "订单时间", key: "time", align: "center" },
        { title: "操作", key: "edit", align: "center", slot: "action" }
      ],
      loadingTable: true,
      page: {
        total: 0,
        page: 1,
        rows: 12
      },
      options: {
        shortcuts: [
          {
            text: "过去一周",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          },
          {
            text: "过去一月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            }
          },
          {
            text: "过去三月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            }
          }
        ]
      },
      rowdata: {},
      goods: [],
      totalmoney: 0, //总金额
      openorderloading: false,
      isorderdel: 0, //是否有商品被删除 0表示没有
      customerType: 0 //客户类型 0零售客户 1批发客户
    };
  },
  created: function() {
    this.cid = JSON.parse(localStorage.getItem("shop")).cid;
    this.sid = JSON.parse(localStorage.getItem("shop")).id;
    var date = new Date();
    this.nowTime =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    this.valuedate[0] = this.getDay(-7);
    this.valuedate[1] = this.nowTime;
    this.getManuscriptList(
      this.page.page,
      this.page.rows,
      this.valuedate[0],
      this.valuedate[1]
    );
    this.getCustomerList();
    this.getAdminList();
  },
  watch: {
    "search.name": {
      deep: true,
      handler: function(newVal, oldVal) {
        this.customerList.forEach(item => {
          if (newVal == item.id) {
            this.search.phone = item.phone;
          }
        });
        this.getManuscriptList(
          this.page.page,
          this.page.rows,
          this.valuedate[0],
          this.valuedate[1]
        );
      }
    },
    "search.openorderName": {
      deep: true,
      handler: function(newVal, oldVal) {
        this.getManuscriptList(
          this.page.page,
          this.page.rows,
          this.valuedate[0],
          this.valuedate[1]
        );
      }
    }
  },
  methods: {
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    //获取列表
    getManuscriptList(page, rows, startTime, endTime) {
      this.$Api
        .getManuscriptList({
          cid: this.cid,
          sid: this.sid,
          page: page,
          rows: rows,
          time: startTime,
          endtime: endTime,
          customerid: this.search.name, //客户id
          adminid: this.search.openorderName //员工id
        })
        .then(res => {
          if (res.code == 200) {
            this.page.total = res.count;
            this.data = res.data;
          } else {
            this.$Message.warning(res.msg);
          }
          this.loadingTable = false;
        });
    },
    //获取客户列表
    getCustomerList() {
      this.$Api
        .getCustomerList({
          cid: this.cid,
          sid: this.sid,
          page: 1,
          rows: 1000,
          isdel: 1
        })
        .then(res => {
          if (res.code == 200) {
            this.customerList = res.data;
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    //删除草稿单暂存单
    deleteManuscript(del) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>你确定删除这条数据吗？</p>",
        onOk: () => {
          this.$Api
            .deleteManuscript({
              id: del.id
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.warning(res.msg);
                this.getManuscriptList(
                  this.page.page,
                  this.page.rows,
                  this.valuedate[0],
                  this.valuedate[1]
                );
              } else {
                this.$Message.warning(res.msg);
              }
            });
        }
      });
    },
    //获取业务员列表
    getAdminList() {
      this.$Api
        .getAdminList({
          cid: this.cid,
          sid: this.sid,
          page: 1,
          rows: 1000,
          isdel: 0
        })
        .then(res => {
          if (res.code == 200) {
            if (res.data != "") {
              this.salesman = res.data;
            }
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },

    //修改时间
    modifyTime(time) {
      this.valuedate[0] = time[0];
      this.valuedate[1] = time[1];
      this.getManuscriptList(
        this.page.page,
        this.page.rows,
        this.valuedate[0],
        this.valuedate[1]
      );
    },
    //修改分页
    onGongPageTotal(num) {
      this.getManuscriptList(
        num,
        this.page.rows,
        this.valuedate[0],
        this.valuedate[1]
      );
    },
    searchCondition() {
      this.getManuscriptList(
        this.page.page,
        this.page.rows,
        this.valuedate[0],
        this.valuedate[1]
      );
    },
    /**
     * 开单
     * */
    fnisdel(strsid) {
      //判断商品是否被禁用

      this.$Api
        .selectGoodsIsShows({
          ids: strsid
        })
        .then(res => {
          if (res.code == 200) {
            if (res.data.length > 0) {
              this.$Message.warning("已有商品被禁用，不能再次开单");
              this.isorderdel = 1;
            }
          } else {
            this.$Message.warning(res.msg);
          }
        })
        .catch(err => {
          this.$Message.warning(err.msg);
        });
    },
    queryManuscript(row) {
      this.isorderdel = 0;
    //   this.openorderloading = true;
      this.rowdata = row;
      this.customerList.forEach(item => {
        if (item.id == row.customerid) {
          this.customerType = item.customerType;
        }
      });

      sessionStorage.removeItem("openorder");
      this.goods = [];
      this.$Api
        .queryManuscript({
          id: row.id
        })
        .then(res => {
          if (res.code == 200) {
            var strsid = "";
            res.data.goods.forEach(item => {
              strsid += item.goodsid + ",";
            });
            this.fnisdel(strsid);
            this.getGoodsList(strsid,res.data.goods);
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    getGoodsList(strsid, goodsList) {
      this.$Api
        .getGoodsList({
          cid: this.cid,
          sid: this.sid,
          page: 1,
          rows: 10,
          condition: "",
          ids: strsid
        })
        .then(res => {
          if (res.code == 200) {
            this.totalmoney = 0;
            res.data.forEach(item => {
              goodsList.forEach(data => {
                if (data.goodsid == item.id) {
                  item.nums = data.nums;
                  item.goodsid = data.goodsid;
                  item.goodsname = item.name;
                  item.sortTime = data.id;
                  data.goodsItem.forEach(m => {
                    item.goodsItem.forEach(k => {
                      var ms = JSON.parse(m.goodsItem);
                      if (ms.supperId == k.goodsid+''+k.colorid+''+k.sizeid) {
                        k.lprice = ms.lprice;
                        k.pprice = ms.pprice;
                        k.nums = ms.nums;
                        k.quantity = ms.nums;
                        k.zkv = ms.zkv;
                        /*此处需要判断是批发客户还是零售散客*/
                        if (this.customerType == 0) {
                            this.totalmoney += (k.quantity * k.lprice * k.zkv) / 100;
                        } else {
                            this.totalmoney += (k.quantity * k.pprice * k.zkv) / 100;
                        }                        
                      }
                    });
                  });
                }
              });
            });
            //过滤0的数据
            var arrs = [];
            res.data.forEach(goods => {
              if (goods.nums != 0) {
                var arrsItem = [];
                goods.goodsItem.forEach((item,index) => {
                    if(item.nums != 0){
                        arrsItem.push(item);
                    }
                });
                goods.goodsItem = arrsItem;
                arrs.push(goods);
              }
            });

            sessionStorage.setItem(
              "openorder",
              JSON.stringify({
                goodslist: arrs,
                totalmoney: this.totalmoney,
                adminName: this.rowdata.adminName,
                adminid: this.rowdata.adminid,
                bankid: this.rowdata.bankid,
                cid: this.rowdata.cid,
                customerName: this.rowdata.customerName,
                customerPhone: this.rowdata.customerPhone,
                customerid: this.rowdata.customerid,
                endtime: this.rowdata.endtime,
                goods: this.rowdata.goods,
                id: this.rowdata.id,
                mlmoney: this.rowdata.mlmoney,
                remarks: this.rowdata.remarks,
                sid: this.rowdata.sid,
                time: this.rowdata.time,
                zkstate: this.rowdata.zkstate
              })
            );
            if(this.isorderdel==0){
                    this.$router.push({path:'/newSale',query:{
                            type:1
                        }
                    })
            }else {
                    this.openorderloading=false
            }
          } else {
            this.$Message.warning(res.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-title {
  line-height: 54px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>